import type Bookmark from './Bookmark';
import type {WebUserContact} from './User';

export const FolderTypename = 'Folder';

export interface Folder {
  __typename: typeof FolderTypename;
  id: string;
  key: string;
  name: string;
}

export interface BookmarkFolder extends Folder {
  channels: string[];
  bookmarks: Bookmark[];
}

export interface SharedFolder extends Folder {
  creator: string;
  sharedWith: WebUserContact[];
}

export enum FolderType {
  ADD = 'ADD',
  APP = 'APP',
  BOOK = 'BOOK',
  BOOKMARK = 'BOOKMARK',
  EXPLORER = 'EXPLORER',
  GAME = 'GAME',
  INFO = 'INFO',
  MUSIC = 'MUSIC',
  NOTE_ONLY = 'NOTE_ONLY',
  OFFICE = 'OFFICE',
  PICTURE_AND_VIDEO = 'PICTURE_AND_VIDEO',
  PICTURE_ONLY = 'PICTURE_ONLY',
}

export const isFolder = (folderOrBookmark: BookmarkFolder | Bookmark) : folderOrBookmark is BookmarkFolder => folderOrBookmark.__typename === FolderTypename;

export default Folder;